const isProductionCheck = () => process.env.REACT_APP_ENV === 'production'
const isStagingCheck = () => process.env.REACT_APP_ENV === 'staging'

const isProduction = isProductionCheck()
const isStaging = isStagingCheck()

export {
    isProduction,
    isStaging
}
